import React, { useState, useEffect, useRef } from 'react'

const Title = ({ children, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.3 }
    )
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={ref} className={`text-center mb-4 ${className}`}>
      <h2 className="text-accent font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight whitespace-nowrap overflow-hidden">
        <span
          className="inline-block"
          style={{
            animation: isVisible ? 'textRevealUp 0.6s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
          }}
        >
          {children}
        </span>
      </h2>
      <div className="flex items-center justify-center mt-4 gap-3 overflow-hidden">
        <div
          className="h-[1px] w-10 lg:w-16 bg-gradient-to-r from-transparent to-accent/60"
          style={{
            animation: isVisible ? 'revealLine 0.8s 0.3s ease-out forwards' : 'none',
            width: isVisible ? undefined : 0,
          }}
        ></div>
        <div
          className="w-2 h-2 rounded-full bg-accent/70"
          style={{
            animation: isVisible ? 'scaleIn 0.4s 0.5s ease-out forwards' : 'none',
            opacity: isVisible ? undefined : 0,
            transform: isVisible ? undefined : 'scale(0)',
          }}
        ></div>
        <div
          className="h-[1px] w-10 lg:w-16 bg-gradient-to-l from-transparent to-accent/60"
          style={{
            animation: isVisible ? 'revealLine 0.8s 0.3s ease-out forwards' : 'none',
            width: isVisible ? undefined : 0,
          }}
        ></div>
      </div>
    </div>
  )
}

export default Title
